


























































































































import { RabatovaSkupina } from '@/modules/ciselnik/skladove/rabatovaSkupina';
import { ZboziDruh } from '@/modules/ciselnik/skladove/zbozidruh';
import { editFactory } from '@/main/pages';
import { formatDecimalValue } from '@/main/utils/stringHelper';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import { showAlert } from '@/main/utils/notifications';
import { types } from './store/types';
import { apiProvider } from './api';
import { NAME, PART_PRICING_LOG } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		ZboziDruhSelect: ZboziDruh.components.Select,
		RabatovaSkupinaSelect: RabatovaSkupina.components.Select,
		DmsPdfDialog,
	},
	data() {
		return {
			showTiskDialog: false,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				rabatSk: `${this.storeUri}/${types.mutations.ND_CENIK_RABAT_SK_SELECT_MAPPER}`,
				zboziDruh: `${this.storeUri}/${types.mutations.ND_CENIK_ZBOZI_DRUH_SELECT_MAPPER}`,
			};
		},
		zboziDruhFilter(): { VyrobekndOzn: string | null } {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		rabatSkFilter(): { VyrobekndOzn: string | null } {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		formattedLocalRrp(): string | null {
			return this.LocalRrp != null ? formatDecimalValue(this.LocalRrp) : this.LocalRrp;
		},
	},
	methods: {
		async loadData() {
			if (this.isCreateMode) {
				this.default();
			} else {
				await this.fetchTableSchemas([PART_PRICING_LOG]);
				await this.entity();
				await this.fetchTableData([PART_PRICING_LOG]);
			}
		},
		tiskClicked() {
			this.showTiskDialog = true;
		},
		async AddUpdatePriceClick() {
			 const { data: partsInfo } = await apiProvider.addUpdatePrice(this.NdNr);
			 if (partsInfo) {
				  showAlert({
					message: partsInfo,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				    });
			    }
			await this.fetchTableData([PART_PRICING_LOG]);
			await this.entity();
		},
		DisponibilitaSpcClick() {
			apiProvider
				.disponibilitaSpc({
					NdNr: this.NdNr,
					VyrobekndOzn: this.VyrobekndOzn,
					Pocet: this.PocetDotaz,
					SkladOzn: this.SkladOzn,
				})
				.then(({ data }) => {
					this.PocetSpc = data.SpcPocet;
				});
		},
	},
});
